import {
    CollisionEventType,
    Component,
    Object3D,
    PhysXComponent,
    Property,
} from '@wonderlandengine/api';
import { property } from '@wonderlandengine/api/decorators.js';
import { TriggerTarget } from './triggerTarget.js';

export class Trigger extends Component {
    static TypeName = 'trigger';
    private _physx?: PhysXComponent;

    @property.array(Property.object())
    targets: Object3D[] = [];

    @property.bool(true)
    triggerOnEnter = true;

    @property.bool(false)
    triggerOnExit = false;

    @property.bool(false)
    once = false;

    private _triggered: boolean = false;
    private _triggerTargets: TriggerTarget[] = [];
    init() {}

    start() {
        this._physx = this.object.getComponent(PhysXComponent)!;
        this._physx?.onCollision(this._onCollision);
        for (const target of this.targets) {
            const triggerTarget = target.getComponent(TriggerTarget);
            if (!triggerTarget) {
                console.warn(
                    `TriggerTarget component not found on target: ${target.name}`
                );
                continue; // Skip if TriggerTarget is not found
            }
            this._triggerTargets.push(triggerTarget);
        }
    }

    update(dt: number) {}

    private _onCollision = (
        type: CollisionEventType,
        other: PhysXComponent
    ) => {
        if (this.once && this._triggered) {
            return; // Ignore further collisions if 'once' is true and already triggered
        }
        if (other.object.name !== 'Player') {
            return; // Ignore collisions with non-player objects
        }
        if (
            (type === CollisionEventType.Touch ||
                type === CollisionEventType.TriggerTouch) &&
            this.triggerOnEnter
        ) {
            this._triggerTargets.forEach((target: TriggerTarget) => {
                target?.execute(); // Execute the trigger target action
            });
            this._triggered = true; // Set triggered to true if it is a one-time trigger
        } else if (
            (type === CollisionEventType.TouchLost ||
                type === CollisionEventType.TriggerTouchLost) &&
            this.triggerOnExit
        ) {
            this._triggerTargets.forEach((target: TriggerTarget) => {
                target?.execute(); // Execute the trigger target action
            });
            this._triggered = true; // Set triggered to true if it is a one-time trigger
        }
    };
}
